import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { api } from '.';
export var apiGetCategories = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var res, _err$response, _err$response$data, _err$response$data$de, _err$response$data$de2, message;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.get("/category");

          case 3:
            res = _context.sent;
            return _context.abrupt("return", [res.data]);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            message = (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : (_err$response$data$de = _err$response$data.detail) === null || _err$response$data$de === void 0 ? void 0 : (_err$response$data$de2 = _err$response$data$de[0]) === null || _err$response$data$de2 === void 0 ? void 0 : _err$response$data$de2.msg;
            console.error("Failed to fetch categories because: ".concat(message));
            return _context.abrupt("return", [null, _context.t0]);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function apiGetCategories() {
    return _ref.apply(this, arguments);
  };
}();